import Model from './model';

export default class Tag extends Model {
  static fields = [
    'id',
    'name',
    { name: 'count', devaultValue: 0 },
  ];
}